import React, { Component } from "react"
import DashNav from "./dash_nav"
import TimeEntryList from "./time_entry_list"
import TimeEntryListByUser from "./time_entry_list_by_user"

class TimeEntries extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {
            handleRangeSelect,
            title,
            onClickBackward,
            onClickForward,
            defaultSelectedOption,
            totalHrs,
            renderButtonBar,
            showByUser,
            userId,
            timeEntries,
            timeEntriesArray,
            timeEntryRollups,
            tags,
            increment,
            createTimeEntry,
            updateTimeEntry,
            teams,
            editTimeEntry,
            isCollapsed,
            runningEntries,
            viewport,
            users,
            selectedTeamMembership,
            trialEnd,
        } = this.props

        return (
            <div>
                <DashNav
                    handleRangeSelect={handleRangeSelect}
                    title={title}
                    onClickBackward={onClickBackward}
                    onClickForward={onClickForward}
                    defaultSelectedOption={defaultSelectedOption}
                    totalHrs={totalHrs}
                    renderButtonBar={renderButtonBar}
                    viewport={viewport}
                />
                {showByUser ? (
                    <TimeEntryListByUser
                        timeEntriesArray={timeEntriesArray}
                        runningEntries={runningEntries}
                        viewport={viewport}
                        tags={tags}
                        users={users}
                        increment={increment}
                        createTimeEntry={createTimeEntry}
                        updateTimeEntry={updateTimeEntry}
                        teams={teams}
                        editTimeEntry={editTimeEntry}
                        isCollapsed={isCollapsed}
                        selectedTeamMembership={selectedTeamMembership}
                        trialEnd={trialEnd}
                        showByUser={showByUser}
                    />
                ) : (
                    <TimeEntryList
                        userId={userId}
                        timeEntries={timeEntries}
                        timeEntryRollups={timeEntryRollups}
                        tags={tags}
                        increment={increment}
                        createTimeEntry={createTimeEntry}
                        updateTimeEntry={updateTimeEntry}
                        teams={teams}
                        editTimeEntry={editTimeEntry}
                        isCollapsed={isCollapsed}
                        trialEnd={trialEnd}
                        showByUser={showByUser}
                    />
                )}
            </div>
        )
    }
}

export default TimeEntries



// WEBPACK FOOTER //
// ./src/components/layout/time_entries.jsx